export const formTemplates = (state) => state.formTemplates
export const selectAllField = (state) => state.selectAllField
export const selectedFormTemplates = (state) => state.selectedFormTemplates
export const totalFormTemplates = (state) => state.totalFormTemplates
export const viewUserGuide = (state) => state.viewUserGuide
